
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Nishank ho nirbhay ho manaan re" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Nishank ho nirbhay ho manaan re" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: 'Swami Samarth, Tarak Mantra, Swami Samarth Tarak Mantra, Swami Samarth Tarak Mantra lyrics, निशंक होई रे मना तारक मंत्र'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Swami Samarth, Tarak Mantra, Chant for safety, Swami Samarth Tarak Mantra, Swami Samarth Tarak Mantra lyrics, Swami Samarth Tarak Mantra lyrics marathi, Swami Samarth Tarak Mantra lyrics english, निशंक होई रे मना तारक मंत्र' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/tarak-mantra.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/tarak-mantra.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Nishank ho nirbhay ho manaan re | Swami Samarth Tarak Mantra - निःशंक हो निर्भय हो मना रे(स्वामी समर्थ तारक मंत्र)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/tarak-mantra"
        },
        "headline": "Nishank ho nirbhay ho manaan re - निःशंक हो निर्भय हो मना रे(स्वामी समर्थ तारक मंत्र)",
        "name" : "Nishank ho nirbhay ho manaan re - Swami Samarth Tarak Mantra",
        "description": "Explore the full lyrics of stotra 'Nishank ho nirbhay ho manaan re' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/tarak-mantra.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
    
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  